import { OnboardingRootState } from "../reducers/rootReducer";
import { initialPitchListState, PitchListState } from "../reducers/pitchListReducer";
import { getOnboardingState } from "./rootSelectors";

export const getPitchListState = (state: OnboardingRootState): PitchListState =>
  getOnboardingState(state)?.pitchList ?? initialPitchListState;

export const getPitchListData = (state: OnboardingRootState) => getPitchListState(state).data;

export const getPitchListIsLoading = (state: OnboardingRootState) =>
  getPitchListState(state).isLoading;

export const getPitchListError = (state: OnboardingRootState) => getPitchListState(state).error;
